export default __webpack_public_path__ + "static/media/LightBlue0005.46187168.png";